export const heroImages = [
  "https://public.readdy.ai/ai/img_res/b9bcccb80654f769e1758e0b8cf96a06.jpg",
];

export const featuredEditorials = [
  {
    id: 1,
    number: "01",
    title: "A Soft Beige Living Room That Breathes",
    excerpt: "How neutral tones and natural materials create a space that feels genuinely calm and inviting.",
    category: "Living Rooms",
    path: "/living-room",
    image: "https://readdy.ai/api/search-image?query=serene%20editorial%20living%20room%20interior%20cream%20linen%20sofa%20natural%20oak%20side%20table%20single%20dried%20flower%20stem%20in%20ceramic%20vase%20warm%20golden%20afternoon%20light%20minimal%20neutral%20tones%20beige%20ivory%20warm%20white%20walls%20clean%20editorial%20photography%20magazine%20style%20calm%20atmosphere&width=900&height=1100&seq=feat1&orientation=portrait",
  },
  {
    id: 2,
    number: "02",
    title: "Books, Light, and a Reading Corner",
    excerpt: "Turning a small space into a personal sanctuary with a warm lamp and soft textiles.",
    category: "Cozy Corners",
    path: "/cozy-corners",
    image: "https://readdy.ai/api/search-image?query=cozy%20intimate%20reading%20nook%20interior%20linen%20armchair%20warm%20ambient%20floor%20lamp%20stack%20of%20books%20small%20wooden%20side%20table%20knit%20throw%20blanket%20soft%20warm%20light%20cream%20ivory%20neutral%20tones%20minimal%20decor%20editorial%20photography%20calm%20quiet%20atmosphere&width=700&height=860&seq=feat2&orientation=portrait",
  },
  {
    id: 3,
    number: "03",
    title: "The Richness of a Minimal Space",
    excerpt: "Less but better — a philosophy of selected materials and slow, intentional living.",
    category: "Style Guide",
    path: "/style-guide",
    image: "https://readdy.ai/api/search-image?query=minimal%20warm%20interior%20detail%20shot%20ceramic%20bowl%20natural%20linen%20folded%20cloth%20dried%20botanicals%20warm%20beige%20background%20natural%20textures%20flat%20lay%20editorial%20high%20end%20photography%20calm%20neutral%20palette%20cream%20ivory%20warm%20white&width=700&height=860&seq=feat3&orientation=portrait",
  },
];

export const journalPosts = [
  {
    id: 1,
    title: "Natural Wood and Linen: A Space That Breathes",
    excerpt: "The richness of materials. How natural textures bring life to a quiet interior.",
    category: "Style Guide",
    readTime: "4 min",
    image: "https://readdy.ai/api/search-image?query=natural%20wood%20linen%20interior%20details%20warm%20oak%20surface%20folded%20linen%20fabric%20natural%20textures%20neutral%20tones%20cream%20beige%20editorial%20photography%20calm%20minimal%20home%20decor%20styling%20warm%20light&width=700&height=500&seq=journal1&orientation=landscape",
  },
  {
    id: 2,
    title: "Window Light: Making Afternoon Sun Your Design Partner",
    excerpt: "How you handle light changes everything. Tips for making a window the room's focal point.",
    category: "Cozy Corners",
    readTime: "3 min",
    image: "https://readdy.ai/api/search-image?query=window%20natural%20light%20interior%20sheer%20linen%20curtain%20soft%20afternoon%20light%20warm%20shadow%20patterns%20minimal%20interior%20neutral%20beige%20cream%20tones%20calm%20peaceful%20atmosphere%20editorial%20photography&width=700&height=500&seq=journal2&orientation=landscape",
  },
  {
    id: 3,
    title: "Understanding the Depth of Neutral Colors",
    excerpt: "The difference between beige, ivory, and cream — and how to layer them beautifully.",
    category: "Style Guide",
    readTime: "5 min",
    image: "https://readdy.ai/api/search-image?query=neutral%20color%20palette%20interior%20beige%20ivory%20cream%20tones%20paint%20swatches%20linen%20fabric%20samples%20natural%20materials%20minimal%20styling%20editorial%20flat%20lay%20warm%20neutral%20tones%20high%20end%20photography&width=700&height=500&seq=journal3&orientation=landscape",
  },
];

export const categories = [
  {
    id: 1,
    name: "Living Rooms",
    description: "Warm neutral spaces done right",
    path: "/living-room",
    image: "https://readdy.ai/api/search-image?query=beautiful%20living%20room%20inspiration%20warm%20neutral%20colors%20beige%20cream%20natural%20wood%20linen%20sofa%20minimal%20cozy%20interior%20warm%20light%20elegant%20styling%20architectural%20photography&width=600&height=750&seq=cat1b&orientation=portrait",
  },
  {
    id: 2,
    name: "Cozy Corners",
    description: "Intimate and calming small spaces",
    path: "/cozy-corners",
    image: "https://readdy.ai/api/search-image?query=cozy%20corner%20reading%20nook%20intimate%20space%20armchair%20lamp%20books%20soft%20neutral%20tones%20cream%20beige%20warm%20atmosphere%20minimal%20interior%20peaceful%20quiet%20editorial%20photography&width=600&height=750&seq=cat2b&orientation=portrait",
  },
  {
    id: 3,
    name: "Style Guide",
    description: "Exploring the neutral aesthetic",
    path: "/style-guide",
    image: "https://readdy.ai/api/search-image?query=interior%20style%20guide%20natural%20materials%20wood%20linen%20ceramic%20minimal%20elegant%20neutral%20palette%20warm%20tones%20design%20inspiration%20editorial%20photography%20close%20up%20textures&width=600&height=750&seq=cat3b&orientation=portrait",
  },
];

export const livingRoomGallery = [
  {
    id: 1,
    title: "A Living Room Unified in Warm White",
    image: "https://readdy.ai/api/search-image?query=warm%20white%20living%20room%20interior%20cream%20sofa%20natural%20oak%20coffee%20table%20linen%20cushions%20soft%20morning%20lighting%20plants%20neutral%20tones%20minimal%20elegant%20cozy%20atmosphere%20wide%20bright%20space%20editorial&width=800&height=600&seq=lr1b&orientation=landscape",
    tags: ["Minimal", "Natural"],
  },
  {
    id: 2,
    title: "Natural Wood and Linen Living Room",
    image: "https://readdy.ai/api/search-image?query=natural%20wood%20and%20linen%20living%20room%20light%20oak%20floors%20cream%20sofa%20warm%20beige%20walls%20large%20windows%20natural%20light%20cozy%20minimal%20scandinavian%20japandi%20style%20plants%20ceramics%20editorial&width=600&height=800&seq=lr2b&orientation=portrait",
    tags: ["Wood", "Linen"],
  },
  {
    id: 3,
    title: "Afternoon Light Flooding the Living Room",
    image: "https://readdy.ai/api/search-image?query=afternoon%20sunlight%20living%20room%20soft%20warm%20light%20beige%20sofa%20natural%20textures%20linen%20curtains%20warm%20wooden%20floor%20minimal%20decor%20peaceful%20atmosphere%20cream%20ivory%20tones%20editorial%20high%20quality&width=800&height=600&seq=lr3b&orientation=landscape",
    tags: ["Natural Light", "Warmth"],
  },
  {
    id: 4,
    title: "A Calm Neutral Living Room",
    image: "https://readdy.ai/api/search-image?query=neutral%20color%20palette%20calm%20living%20room%20soft%20beige%20cream%20minimal%20furniture%20natural%20materials%20linen%20sofa%20ceramic%20vase%20dried%20flowers%20cozy%20elegant%20interior%20editorial%20photography&width=600&height=800&seq=lr4b&orientation=portrait",
    tags: ["Neutral", "Elegant"],
  },
  {
    id: 5,
    title: "Simple Furniture and Large Windows",
    image: "https://readdy.ai/api/search-image?query=simple%20furniture%20large%20windows%20bright%20living%20room%20minimal%20interior%20light%20cream%20walls%20natural%20wood%20floor%20few%20carefully%20chosen%20pieces%20airy%20open%20space%20warm%20tones%20plants%20high%20end%20editorial&width=800&height=600&seq=lr5b&orientation=landscape",
    tags: ["Airy", "Bright"],
  },
  {
    id: 6,
    title: "A Minimal Living Room Rich in Texture",
    image: "https://readdy.ai/api/search-image?query=textured%20minimal%20living%20room%20woven%20throw%20blanket%20linen%20cushions%20ceramic%20decor%20natural%20rattan%20basket%20warm%20neutral%20tones%20cozy%20details%20layered%20textures%20cream%20beige%20editorial%20magazine%20style&width=600&height=800&seq=lr6b&orientation=portrait",
    tags: ["Texture", "Detail"],
  },
];

export const cozyCornersGallery = [
  {
    id: 1,
    title: "A Reading Corner by the Window",
    image: "https://readdy.ai/api/search-image?query=window%20side%20reading%20nook%20comfortable%20linen%20armchair%20warm%20lamp%20books%20soft%20light%20from%20window%20cream%20cushions%20small%20side%20table%20peaceful%20cozy%20corner%20neutral%20tones%20editorial&width=800&height=600&seq=cc1b&orientation=landscape",
    tags: ["Reading", "Window"],
  },
  {
    id: 2,
    title: "Warm Lamp and Soft Armchair",
    image: "https://readdy.ai/api/search-image?query=cozy%20armchair%20warm%20floor%20lamp%20reading%20corner%20soft%20linen%20upholstery%20warm%20glow%20books%20stack%20minimal%20decor%20cream%20and%20warm%20beige%20tones%20intimate%20atmosphere%20evening%20soft%20light%20editorial&width=600&height=800&seq=cc2b&orientation=portrait",
    tags: ["Lamp", "Armchair"],
  },
  {
    id: 3,
    title: "A Relaxing Corner in a Small Space",
    image: "https://readdy.ai/api/search-image?query=small%20corner%20relax%20space%20cozy%20cushions%20knit%20throw%20blanket%20warm%20ambient%20light%20minimal%20decor%20neutral%20cream%20beige%20tones%20intimate%20cozy%20nook%20plants%20books%20editorial%20photography&width=800&height=600&seq=cc3b&orientation=landscape",
    tags: ["Small Space", "Comfort"],
  },
  {
    id: 4,
    title: "Window Bench with Soft Cushions",
    image: "https://readdy.ai/api/search-image?query=window%20bench%20seat%20soft%20cushions%20linen%20pillows%20cozy%20corner%20natural%20light%20warm%20neutral%20tones%20cream%20beige%20minimal%20styling%20plants%20books%20peaceful%20atmosphere%20editorial%20photography&width=600&height=800&seq=cc4b&orientation=portrait",
    tags: ["Bench", "Window"],
  },
  {
    id: 5,
    title: "A Corner Wrapped in Soft Textiles",
    image: "https://readdy.ai/api/search-image?query=soft%20textiles%20cozy%20corner%20fluffy%20throw%20blanket%20linen%20cushions%20warm%20floor%20lamp%20small%20tray%20with%20candle%20tea%20cup%20cream%20ivory%20neutral%20tones%20intimate%20peaceful%20hygge%20editorial&width=800&height=600&seq=cc5b&orientation=landscape",
    tags: ["Textiles", "Warmth"],
  },
  {
    id: 6,
    title: "A Private Space Beside the Bookshelf",
    image: "https://readdy.ai/api/search-image?query=bookshelf%20corner%20reading%20private%20space%20warm%20wooden%20shelves%20books%20cozy%20armchair%20soft%20lamp%20warm%20neutral%20tones%20cream%20beige%20minimal%20personal%20sanctuary%20calm%20atmosphere%20editorial&width=600&height=800&seq=cc6b&orientation=portrait",
    tags: ["Bookshelf", "Private"],
  },
];

export const styleGuideColors = [
  { name: "Warm White", hex: "#FAF7F0", desc: "A clean and warm base for any space" },
  { name: "Ivory", hex: "#F5F1E8", desc: "Adds a soft layer of quiet depth" },
  { name: "Cream", hex: "#EDE6DA", desc: "A colour that wraps the room gently" },
  { name: "Soft Beige", hex: "#D9CEBC", desc: "Grounded warmth rooted in nature" },
  { name: "Warm Taupe", hex: "#B5A898", desc: "A refined and sophisticated neutral" },
  { name: "Light Oak", hex: "#C8A87A", desc: "The warmth of natural wood tones" },
];

export const styleGuideMaterials = [
  {
    name: "Linen",
    desc: "A breathing natural fabric. Wrinkles become part of its beauty, growing lovelier with time.",
    image: "https://readdy.ai/api/search-image?query=natural%20linen%20fabric%20texture%20close%20up%20warm%20beige%20ivory%20tones%20soft%20cloth%20folds%20natural%20material%20editorial%20photography%20minimal%20background&width=600&height=400&seq=mat1&orientation=landscape",
  },
  {
    name: "Natural Oak",
    desc: "Wood grain brings life to a space. Light, warm, and full of quiet presence.",
    image: "https://readdy.ai/api/search-image?query=natural%20oak%20wood%20texture%20close%20up%20warm%20light%20wood%20grain%20detail%20editorial%20photography%20minimal%20background%20neutral%20tones&width=600&height=400&seq=mat2&orientation=landscape",
  },
  {
    name: "Ceramics",
    desc: "Handmade pieces that carry the trace of their making — beauty found in imperfection.",
    image: "https://readdy.ai/api/search-image?query=handmade%20ceramic%20pottery%20close%20up%20natural%20clay%20texture%20warm%20neutral%20tones%20minimal%20editorial%20photography%20japanese%20style%20wabi%20sabi&width=600&height=400&seq=mat3&orientation=landscape",
  },
  {
    name: "Rattan and Wicker",
    desc: "Organic curves that bring a gentle rhythm and natural craft to any interior.",
    image: "https://readdy.ai/api/search-image?query=rattan%20wicker%20basket%20weave%20texture%20close%20up%20natural%20material%20warm%20neutral%20tones%20editorial%20photography%20minimal%20background%20home%20decor&width=600&height=400&seq=mat4&orientation=landscape",
  },
];

export const featuredInspirations = [
  {
    id: 1,
    title: "Calm Living Room Ideas in Soft Beige",
    category: "Living Rooms",
    path: "/living-room",
    image: "https://readdy.ai/api/search-image?query=calm%20soft%20beige%20living%20room%20interior%20cream%20linen%20sofa%20natural%20wood%20coffee%20table%20minimal%20decor%20dried%20botanicals%20warm%20neutral%20editorial%20photography%20warm%20afternoon%20light%20serene%20atmosphere&width=640&height=800&seq=fi1&orientation=portrait",
  },
  {
    id: 2,
    title: "Cozy Reading Corner Inspiration",
    category: "Cozy Corners",
    path: "/cozy-corners",
    image: "https://readdy.ai/api/search-image?query=cozy%20intimate%20reading%20corner%20linen%20armchair%20warm%20floor%20lamp%20stack%20of%20books%20knit%20throw%20cream%20ivory%20neutral%20tones%20window%20light%20editorial%20photography%20peaceful%20atmosphere&width=640&height=800&seq=fi2&orientation=portrait",
  },
  {
    id: 3,
    title: "Warm Minimal Home Decor Ideas",
    category: "Style Guide",
    path: "/style-guide",
    image: "https://readdy.ai/api/search-image?query=warm%20minimal%20home%20decor%20details%20ceramic%20vase%20dried%20flowers%20natural%20linen%20warm%20beige%20neutral%20tones%20editorial%20high%20end%20interior%20photography%20flat%20lay%20close%20up%20calm%20peaceful&width=640&height=800&seq=fi3&orientation=portrait",
  },
  {
    id: 4,
    title: "Quiet Window Nook Styling",
    category: "Cozy Corners",
    path: "/cozy-corners",
    image: "https://readdy.ai/api/search-image?query=quiet%20window%20seat%20nook%20soft%20cushions%20linen%20pillows%20natural%20light%20sheer%20curtain%20cream%20beige%20minimal%20calm%20interior%20editorial%20photography%20serene%20atmosphere&width=640&height=800&seq=fi4&orientation=portrait",
  },
  {
    id: 5,
    title: "Natural Wood and Linen Interior Looks",
    category: "Style Guide",
    path: "/style-guide",
    image: "https://readdy.ai/api/search-image?query=natural%20wood%20and%20linen%20interior%20look%20oak%20furniture%20linen%20fabric%20warm%20neutral%20tones%20minimal%20scandinavian%20japandi%20style%20editorial%20interior%20photography%20calm%20serene&width=640&height=800&seq=fi5&orientation=portrait",
  },
  {
    id: 6,
    title: "Soft Light Living Room Inspiration",
    category: "Living Rooms",
    path: "/living-room",
    image: "https://readdy.ai/api/search-image?query=soft%20light%20living%20room%20morning%20sunlight%20sheer%20linen%20curtain%20cream%20sofa%20warm%20oak%20floor%20plants%20minimal%20decor%20peaceful%20editorial%20photography%20neutral%20beige%20ivory%20atmosphere&width=640&height=800&seq=fi6&orientation=portrait",
  },
];

export const popularSpaces = [
  {
    id: 1,
    title: "The Perfect Linen Living Room",
    category: "Living Rooms",
    image: "https://readdy.ai/api/search-image?query=perfect%20linen%20living%20room%20wide%20angle%20warm%20cream%20linen%20sofa%20natural%20wood%20large%20windows%20morning%20light%20minimal%20calm%20editorial%20architectural%20photography%20beautiful%20neutral%20palette%20beige%20ivory&width=900&height=620&seq=pop1&orientation=landscape",
  },
  {
    id: 2,
    title: "Golden Hour Reading Nook",
    category: "Cozy Corners",
    image: "https://readdy.ai/api/search-image?query=golden%20hour%20reading%20nook%20armchair%20warm%20amber%20lamp%20glow%20books%20knit%20throw%20window%20light%20cream%20ivory%20neutral%20tones%20cozy%20intimate%20editorial%20photography%20evening%20atmosphere&width=640&height=480&seq=pop2&orientation=landscape",
  },
  {
    id: 3,
    title: "Minimal Oak and Cream Living Space",
    category: "Living Rooms",
    image: "https://readdy.ai/api/search-image?query=minimal%20oak%20and%20cream%20living%20space%20natural%20wood%20furniture%20cream%20walls%20plants%20minimal%20decor%20warm%20neutral%20tones%20serene%20calm%20editorial%20interior%20photography%20wide%20angle&width=640&height=480&seq=pop3&orientation=landscape",
  },
  {
    id: 4,
    title: "Linen Textures and Natural Light",
    category: "Style Guide",
    image: "https://readdy.ai/api/search-image?query=linen%20textures%20natural%20light%20interior%20warm%20fabric%20folds%20soft%20light%20window%20sheer%20curtain%20cream%20neutral%20editorial%20photography%20minimal%20calm%20atmosphere&width=640&height=480&seq=pop4&orientation=landscape",
  },
  {
    id: 5,
    title: "Quiet Afternoon in the Corner Chair",
    category: "Cozy Corners",
    image: "https://readdy.ai/api/search-image?query=quiet%20afternoon%20corner%20chair%20linen%20armchair%20soft%20light%20small%20side%20table%20tea%20cup%20ceramic%20warm%20neutral%20cream%20beige%20editorial%20interior%20photography%20calm%20atmosphere&width=640&height=480&seq=pop5&orientation=landscape",
  },
  {
    id: 6,
    title: "Warm Minimalism Done Right",
    category: "Style Guide",
    image: "https://readdy.ai/api/search-image?query=warm%20minimalism%20interior%20done%20right%20natural%20wood%20minimal%20decor%20ceramic%20objects%20botanicals%20linen%20warm%20beige%20neutral%20tones%20editorial%20high%20end%20interior%20photography%20calm%20serene%20atmosphere&width=640&height=480&seq=pop6&orientation=landscape",
  },
];

export const livingRoomPosts = [
  {
    id: 1,
    title: "Calm Living Room Ideas in Soft Beige",
    excerpt: "Warm neutrals and natural textures that feel effortlessly put together.",
    category: "Soft Beige",
    image: "https://readdy.ai/api/search-image?query=calm%20living%20room%20soft%20beige%20tones%20wide%20angle%20oversized%20cream%20linen%20sofa%20natural%20oak%20coffee%20table%20morning%20light%20sheer%20curtains%20dried%20botanicals%20minimal%20decor%20warm%20neutral%20editorial%20architecture%20photography%20serene%20peaceful%20beautiful&width=900&height=560&seq=lrpost1&orientation=landscape",
  },
  {
    id: 2,
    title: "Sunlit Neutral Living Room Inspiration",
    excerpt: "Morning light flooding through sheer linen, touching every warm surface.",
    category: "Natural Light",
    image: "https://static.readdy.ai/image/c4eeca658c12f593a9351081479c9ecb/81d28feddcf3ac0df3cd708b2d0ccd26.jpeg",
  },
  {
    id: 3,
    title: "Soft Minimal Living Room Aesthetic",
    excerpt: "A quiet space where every object has purpose and every surface breathes.",
    category: "Minimal Warm",
    image: "https://readdy.ai/api/search-image?query=soft%20minimal%20living%20room%20aesthetic%20clean%20lines%20few%20furniture%20pieces%20cream%20walls%20linen%20sofa%20natural%20light%20warm%20neutral%20tones%20calm%20serene%20editorial%20photography%20architectural&width=640&height=480&seq=lrpost3&orientation=landscape",
  },
  {
    id: 4,
    title: "Warm Beige Living Room with Natural Wood",
    excerpt: "Oak tones and muted warmth layered to create a deeply grounding space.",
    category: "Soft Beige",
    image: "https://readdy.ai/api/search-image?query=warm%20beige%20living%20room%20natural%20wood%20furniture%20oak%20shelf%20cream%20sofa%20linen%20cushions%20plants%20ceramics%20warm%20neutral%20editorial%20photography%20interior%20calm%20peaceful%20atmosphere&width=640&height=480&seq=lrpost4&orientation=landscape",
  },
  {
    id: 5,
    title: "Airy Minimal Interior in Soft Tones",
    excerpt: "Spacious, unhurried, and full of gentle light and quiet beauty.",
    category: "Natural Light",
    image: "https://readdy.ai/api/search-image?query=airy%20minimal%20interior%20soft%20tones%20open%20living%20room%20large%20windows%20natural%20light%20cream%20ivory%20walls%20few%20objects%20linen%20fabric%20calm%20serene%20editorial%20photography%20beautiful%20atmosphere&width=640&height=480&seq=lrpost5&orientation=landscape",
  },
  {
    id: 6,
    title: "Linen Sofa and Oak Details",
    excerpt: "Natural textures that age beautifully and soften every corner they touch.",
    category: "Minimal Warm",
    image: "https://readdy.ai/api/search-image?query=linen%20sofa%20oak%20details%20living%20room%20natural%20textures%20warm%20wood%20side%20table%20ceramic%20vase%20dried%20grass%20cream%20neutral%20tones%20editorial%20photography%20interior%20minimal%20calm%20atmosphere&width=640&height=480&seq=lrpost6&orientation=landscape",
  },
];

export const cozyCornersPostGrid = [
  {
    id: 1,
    title: "Cozy Reading Corner Inspiration",
    excerpt: "A soft armchair, warm lamp, and a stack of books — the perfect retreat.",
    category: "Reading Corners",
    image: "https://readdy.ai/api/search-image?query=cozy%20reading%20corner%20linen%20armchair%20warm%20floor%20lamp%20books%20stacked%20knit%20blanket%20cream%20beige%20neutral%20tones%20intimate%20calm%20evening%20editorial%20photography%20portrait%20beautiful%20atmosphere&width=640&height=820&seq=ccgrid1&orientation=portrait",
  },
  {
    id: 2,
    title: "A Perfect Window Reading Nook",
    excerpt: "Soft cushions, sheer linen, and afternoon light that never disappoints.",
    category: "Window Nooks",
    image: "https://readdy.ai/api/search-image?query=window%20reading%20nook%20bench%20seat%20soft%20cushions%20linen%20pillows%20natural%20afternoon%20light%20sheer%20curtain%20cream%20beige%20neutral%20tones%20calm%20peaceful%20editorial%20interior%20photography&width=800&height=500&seq=ccgrid2&orientation=landscape",
  },
  {
    id: 3,
    title: "Warm Lamp and Linen Chair Setup",
    excerpt: "Golden hour in your favorite corner — captured in warm light and soft cloth.",
    category: "Reading Corners",
    image: "https://readdy.ai/api/search-image?query=warm%20lamp%20linen%20chair%20setup%20cozy%20corner%20amber%20light%20soft%20fabric%20throw%20blanket%20books%20cream%20ivory%20tones%20intimate%20evening%20atmosphere%20editorial%20photography%20calm%20home&width=800&height=500&seq=ccgrid3&orientation=landscape",
  },
  {
    id: 4,
    title: "Small Cozy Corner with Big Calm",
    excerpt: "Even the smallest corner can hold a world of quiet and warmth.",
    category: "Small Space Calm",
    image: "https://readdy.ai/api/search-image?query=small%20cozy%20corner%20calm%20space%20minimal%20decor%20warm%20lamp%20cushion%20plants%20books%20cream%20beige%20warm%20neutral%20tones%20intimate%20editorial%20photography%20interior&width=640&height=500&seq=ccgrid4&orientation=landscape",
  },
  {
    id: 5,
    title: "Quiet Morning Corner Styling",
    excerpt: "Start soft. A corner bathed in morning light and unhurried warmth.",
    category: "Window Nooks",
    image: "https://readdy.ai/api/search-image?query=quiet%20morning%20corner%20styling%20warm%20light%20window%20armchair%20small%20tray%20tea%20cup%20ceramic%20warm%20neutral%20cream%20beige%20editorial%20interior%20photography%20calm%20atmosphere&width=640&height=500&seq=ccgrid5&orientation=landscape",
  },
  {
    id: 6,
    title: "Bookshelf Corner for a Calm Home",
    excerpt: "Books as decor, as comfort, as a quiet invitation to slow down.",
    category: "Reading Corners",
    image: "https://readdy.ai/api/search-image?query=bookshelf%20corner%20calm%20home%20warm%20wood%20shelves%20books%20cozy%20armchair%20lamp%20neutral%20tones%20cream%20beige%20minimal%20personal%20sanctuary%20editorial%20photography%20interior%20atmosphere&width=640&height=500&seq=ccgrid6&orientation=landscape",
  },
];
